export default "__VITE_ASSET__BiBfxvwv__"